<template>
    <div class="footer-head">
        <v-container>
            <v-row v-bind="{ ...headRowAttrs }">
                <v-col v-if="this.$slots['default']" v-bind="{ ...headDefaultAttrs }">
                    <slot />
                </v-col>
                <v-col v-if="this.$slots['left']" v-bind="{ ...headLeftAttrs }">
                    <slot name="left" />
                </v-col>
                <v-col v-if="this.$slots['center']" v-bind="{ ...headCenterAttrs }">
                    <slot name="center" />
                </v-col>
                <v-col v-if="this.$slots['right']" v-bind="{ ...headRightAttrs }">
                    <slot name="right" />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    props: {
        headRowAttrs: { type: Object, default: () => ({}) },
        headDefaultAttrs: { type: Object, default: () => ({}) },
        headLeftAttrs: { type: Object, default: () => ({}) },
        headCenterAttrs: { type: Object, default: () => ({}) },
        headRightAttrs: { type: Object, default: () => ({}) },
    },
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
